<template>
    <MiniBetSlip
        class="MiniBetBuilderSlip_Btn_Expand"
        v-bind:count="ticketCount"
        v-bind:title="title"
        v-bind:odds="totalOddsDisplay"
        v-bind:maxPayout="totalPayoutDisplay"
        v-on:click="showMediumBetSlip"
    />
</template>

<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed, onUnmounted, ref } from 'vue';
    import MiniBetSlip from '@/components/betSlip/MiniBetSlip.vue';
    import { i18n } from '@/libraries/i18n';
    import { useBetBuilderBetSlipStore } from '@/stores/betSlip/betBuilderBetSlipStore';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';

    const { showMediumBetSlip } = useBetSlipStore();

    const {
        totalOddsDisplay,
        ticketCount,
        totalPayoutDisplay,
    } = storeToRefs(useBetBuilderBetSlipStore());

    const { refresh } = useBetBuilderBetSlipStore();

    const title = computed(() => i18n.t('bet_builder'));

    const ticks = ref(0);
    async function tick() {
        ticks.value++;
        const refreshOpenTicketSeconds = 15;
        if (ticks.value >= refreshOpenTicketSeconds) {
            await refresh();
            ticks.value = 0;
        }
    }

    window.eventEmitter.on('tick', tick);

    onUnmounted(() => {
        window.eventEmitter.off('tick', tick);
    });
</script>
